import { appData } from '@/mocks/home';

export default function AppSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
  };

  return (
    <section id="app" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-100/70 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
              {appData.title}
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-md mx-auto lg:mx-0">
              {appData.description}
            </p>
            <div className="flex flex-wrap items-center gap-3 mt-5 justify-center lg:justify-start">
              {appData.features.map((f) => (
                <span
                  key={f}
                  className="px-3 py-1.5 bg-background-50 text-xs font-medium text-foreground-700 rounded-full border border-background-200/70"
                >
                  <i className="ri-check-line text-primary-500 mr-1"></i>
                  {f}
                </span>
              ))}
            </div>
            <a
              href="#hero"
              onClick={handleClick}
              className="whitespace-nowrap inline-flex items-center gap-2 mt-6 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold rounded-full transition-all duration-200 cursor-pointer no-underline"
            >
              <i className="ri-smartphone-line"></i>
              手机端立即体验
            </a>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[320px] aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20a%20clean%20movie%20streaming%20interface%20with%20warm%20red%20and%20golden%20accents%2C%20modern%20UI%20design%2C%20cinematic%20thumbnails%2C%20dark%20mode%2C%20product%20mockup&width=640&height=1136&seq=app-mobile-51&orientation=portrait"
                alt="51影院手机端观影体验"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}